export const infiltrometerTypes = {
   MiniDisk:{
       radius: 2.25,
       displayName: "Mini Disk"
   },
   MiniDiskV1:{
       radius: 1.6,
       displayName: "Mini Disk Version 1"
   }
}